import React from 'react'


const MenuItemSingle = ({linktext, link}) => (
    link ? (
        <a href={link} className='item-text item-text-link text-light' target="_blank">{linktext}</a>
    ):(
        <p className="item-text text-light">{linktext}</p>
    )
)

export default MenuItemSingle